import { defineStore } from 'pinia'

export interface IAppState {
  isCollapse: boolean
  name?: string
  doctitle?: string
}

export const useAppStore = defineStore('useAppStore', {
  state: (): IAppState => {
    return {
      isCollapse: false,
      name: '',
      doctitle: '',
    }
  },
  actions: {
    collapse() {
      this.isCollapse = !this.isCollapse
    },
    appName(appinfo) {
      this.name = appinfo.name
    },
    changeTitle(title) {
      this.doctitle = title
    },
  },
})
